import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';
import { handle404AsNull } from '../utils';

const BRANDING_SETTINGS_QUERY_KEY = 'accountProfile/branding';

export function useBrandingSettingsQuery(
	params: { impersonationContext?: Api.IImpersonationContext; enabled?: boolean } = {}
) {
	const userSession = useUserSession();
	return useQuery<Api.BrandingSettings | null>({
		queryFn: handle404AsNull(async () => {
			return userSession.webServiceHelper.callAsync<Api.BrandingSettings>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'accountProfile/branding',
					impersonationContext: params.impersonationContext,
				}),
				'GET'
			);
		}),
		queryKey: [BRANDING_SETTINGS_QUERY_KEY, params.impersonationContext],
		enabled: params.enabled ?? true,
	});
}

export function invalidateBrandingSettingsQueries(params: { impersonationContext?: Api.IImpersonationContext } = {}) {
	return reactQueryClient.invalidateQueries({
		queryKey: [BRANDING_SETTINGS_QUERY_KEY, params.impersonationContext],
	});
}
